import { useNavigate, useParams } from "react-router-dom";
import { BlockingPage } from "@/components/BlockingPage";
import { LottieSpinner } from "@/components/ui/LottieSpinner";
import { useOrganizationAccess } from "@/hooks/organizations/useOrganizationAccess";

/**
 * Garde d'un tableau de bord d'organisation (`/club/:orgId`, `/association/:orgId`).
 * Se place DANS `ProtectedRoute`, qui a déjà vérifié la session et le rôle : ici on
 * vérifie l'appartenance à l'organisation de l'adresse (RET-23).
 */
export function ProtectedOrganizationRoute({ children }: { children: React.ReactNode }) {
  const { orgId } = useParams();
  const navigate = useNavigate();
  const { hasAccess, isLoading } = useOrganizationAccess(orgId);

  if (isLoading) return <LottieSpinner />;

  if (!hasAccess) {
    return (
      <BlockingPage
        title="Accès refusé"
        message="Vous ne faites pas partie de l'équipe de cette organisation."
        actions={[{ label: "Retour à l'accueil", onClick: () => navigate("/") }]}
      />
    );
  }

  return <>{children}</>;
}
